import { Injectable, Inject } from "@angular/core";
import { DOCUMENT } from "@angular/common";

@Injectable({ providedIn: "root" })
export class SeoService {
  constructor(@Inject(DOCUMENT) private doc: Document) {}

  setJSONLD(schemaObject: any) {
    const existing = this.doc.querySelectorAll(
      'script[type="application/ld+json"]'
    );
    existing.forEach((el) => el.remove());

    const script = this.doc.createElement("script");
    script.type = "application/ld+json";
    script.text = JSON.stringify(schemaObject);
    this.doc.head.appendChild(script);
  }
}
